import { toast } from "react-toastify";
import { updateGridStatus as updateGridStatusService } from "../../../api/ApiGrid";
import authService from "../../../services/AuthService";
import { buildCQLFilter } from "../../../services/MapCore/MapCQLFilterService";
import { translations } from "../../../utils/i18n/translations";
import { DefaultLayer } from "../DefaultLayer";
import { WmsLayer } from "../WmsLayer";
import i18n from "../../../utils/i18n";
import { GridFeatureLayer } from "./Components/GridFeatureLayer";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { ChangeGridTool } from "../../../components/CustomComponents/LayerTools/ChangeGridTool/ChangeGridTool";

class GridLayer extends WmsLayer {
  constructor(layer_data, layer_group_id) {
    // console.log("GridLayer constructor");
    super(layer_data, layer_group_id);

    this.id = this.id.replace(layer_data.uuid, `grid-${layer_data.uuid}`);
  }

  getLayerTools(i18n) {
    const tools = super.getLayerTools(i18n);

    tools.push({ button: <ChangeGridTool key={this.id} layer={this} /> });

    return tools;
  }

  getActionsOnRightClick = ({ event, map }) => {
    // console.log("GridLayer getActionsOnRightClick");

    return [
      {
        label: "change_grid_status",
        items: [
          {
            label: "CLEAR",
            action: () =>
              this.updateGridStatus({
                status: "CLEAR",
                event,
                map,
              }),
            icon: (
              <CheckIcon style={{ backgroundColor: "green", color: "white" }} />
            ),
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)", // Color de fondo en hover (puedes personalizarlo)
                // color: "#1976d2", // Cambia el color del texto al hacer hover
              },
            },
          },
          {
            label: "IN_REVIEW",
            action: () =>
              this.updateGridStatus({
                status: "IN_REVIEW",
                event,
                map,
              }),
            icon: (
              <QuestionMarkIcon
                style={{ backgroundColor: "#90EE90", color: "white" }}
              />
            ),

            style: {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)", // Color de fondo en hover (puedes personalizarlo)
                // color: "#1976d2", // Cambia el color del texto al hacer hover
              },
            },
          },
          {
            label: "REVIEWED",
            action: () =>
              this.updateGridStatus({
                status: "REVIEWED",
                event,
                map,
              }),
            icon: (
              <QuestionMarkIcon
                style={{ backgroundColor: "#FF7900", color: "white" }}
              />
            ),

            style: {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)", // Color de fondo en hover (puedes personalizarlo)
                // color: "#1976d2", // Cambia el color del texto al hacer hover
              },
            },
          },
          {
            label: "IN_PROGRESS",
            action: () =>
              this.updateGridStatus({
                status: "IN_PROGRESS",
                event,
                map,
              }),
            icon: (
              <MoreHorizIcon
                style={{ backgroundColor: "blue", color: "white" }}
              />
            ),

            style: {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)", // Color de fondo en hover (puedes personalizarlo)
                // color: "#1976d2", // Cambia el color del texto al hacer hover
              },
            },
          },
          {
            label: "PENDING",

            action: () =>
              this.updateGridStatus({
                status: "PENDING",
                event,
                map,
              }),
            icon: (
              <CloseIcon style={{ backgroundColor: "red", color: "white" }} />
            ),

            style: {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)", // Color de fondo en hover (puedes personalizarlo)
                // color: "#1976d2", // Cambia el color del texto al hacer hover
              },
            },
          },
        ],
      },
      { divider: true },
    ];
  };

  updateGridStatus = async ({ status, event, map }) => {
    const feature = await this.getFeatureInfoOnClick(event, map);
    // console.log("updateGridStatus evt", event, "map", map, "feature", feature);
    if (feature.length === 0) {
      toast.error(translations[i18n.language].no_grid_to_update, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        // transition: Bounce,
      });
      return;
    }
    const toast_id = toast.info(
      `${translations[i18n.language].changing_grid_status}...`,
      {
        // position: "top-right",
        loading: true,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );
    updateGridStatusService(feature[0].properties.uuid, status);
    this.layer.getSource().updateParams({ t: Date.now() });
    toast.update(toast_id, {
      render: translations[i18n.language].grid_status_changed_successfully,
      type: "success",
      isLoading: false,
      //delay: 1,
      autoClose: 10000,
      // closeButton: (
      //   <UndoButton
      //     item_uuid={newElement.uuid}
      //     layerUuid={preliminar_layer_uuid}
      //     map={map}
      //   />
      // ),
    });
  };

  getFeatureComponent(feature) {
    return <GridFeatureLayer feature={feature} key={this.id} />;
  }
}

export { GridLayer };
